import { useEffect, useState, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AppProvider } from "@toolpad/core/react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";
import { createTheme } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import logo from "./images/scrapyard W.png";
import { AuthProvider } from "./contexts/AuthContext";
import * as services from "./services/saleng";

const theme = createTheme({
  typography: {
    fontFamily: '"IBM Plex Sans Thai", serif',
  },
  cssVariables: {
    colorSchemeSelector: "data-toolpad-color-scheme",
  },
  colorSchemes: { light: true },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#185519",
          color: "#fff",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          // minHeight: "48px !important", // ลดความสูงขั้นต่ำ
          // paddingTop: "0px",
          // paddingBottom: "0px",
          "& .MuiTypography-root": {
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "1.1rem", // ลดขนาดฟอนต์นิดหน่อย
          },
          "&.Mui-selected": {
            backgroundColor: "#FCDE70",
            "&:hover": {
              backgroundColor: "#E8B86D",
            },
          },
        },
      },
    },
  },
});

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const logout = () => {
      localStorage.removeItem("accessToken");
      setSession(null);
      navigate("/auth/login");
    };

    const validateSession = async () => {
      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        logout();
        return;
      }

      try {
        const decoded = jwtDecode(accessToken);

        // ตรวจสอบเวลาหมดอายุ (exp) กับเวลาปัจจุบัน
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          console.log("Token has expired");
          logout();
          return;
        }

        const authResponse = await services.getAuthUser();
        const authUser = authResponse.data?.data;
        const shopResponse = await services.getShop();
        const shop = shopResponse.data.data;
        const selectedBranchId = Number(
          localStorage.getItem("branchId") || decoded?.branchId,
        );
        const branch = shop?.branches?.find(
          (item) => Number(item.id) === selectedBranchId,
        );
        const branchName = branch?.name || decoded?.branchId || "ไม่ระบุสาขา";
        const roleName = decoded?.role || "ไม่ระบุตำแหน่ง";
        const displayName =
          [authUser?.name, authUser?.lastname].filter(Boolean).join(" ") ||
          decoded.username;

        if (!isMounted) return;

        setSession({
          user: {
            name: displayName,
            branchName,
            roleName,
            companyName: branch?.companyName || "ไม่ระบุบริษัท",
            // image: <AccountCircleIcon />,
          },
        });
      } catch (error) {
        console.error("Error validating token:", error);
        logout();
      }
    };

    validateSession();

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  const [session, setSession] = useState({});

  const authentication = useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: "",
            email: "",
            image: <AccountCircleIcon />,
          },
        });
      },
      signOut: async () => {
        await auth.signOut();
        localStorage.removeItem("accessToken");
        setSession(null);
        navigate("/auth/login");
      },
    };
  }, [navigate]);

  return (
    <AuthProvider>
      <AppProvider
        theme={theme}
        session={session}
        authentication={authentication}
        branding={{
          logo: <img src={logo} alt=" Logo" style={{ marginRight: 10 }} />,
          title: "",
        }}
      >
        <Outlet />
      </AppProvider>
    </AuthProvider>
  );
}
